import { useAccessibleStudentCategories } from '@/hooks/useAccessibleStudentCategories';

export const useHasSchoolDepartmentAccess = (): boolean => {
  const accessibleCategories = useAccessibleStudentCategories();
  return accessibleCategories.length > 0;
};
